<template>
  <Card>
    <h5 v-if="userType === 'carrier'" slot="title">
      <i class="fa fa-truck" aria-hidden="true" style="font-size: 14px;"></i>
      Sender: {{ sender }}
    </h5>
    <Steps
      :current="statusStep"
      :status="status"
      :direction="directionString"
      v-if="hackReset"
    >
      <Step title="Booked" :content="bookTime"></Step>
      <Step
        v-if="statusStep !== 5 && statusStep === 1 && userType !== 'guest'"
        title="Awaiting Pickup"
        content="Already picked up?"
        id="awaitingPickup"
        @click.native="$emit('mark-pickedup')"
      ></Step>
      <Step
        v-if="statusStep !== 5 && statusStep === 1 && userType === 'guest'"
        title="Awaiting Pickup"
      ></Step>
      <Step
        v-if="statusStep !== 5 && statusStep !== 1"
        title="Awaiting Pickup"
        content=""
      ></Step>
      <Step
        v-show="statusStep !== 5"
        title="Picked Up"
        :content="pickupTime"
      ></Step>
      <Step
        v-if="statusStep !== 5 && statusStep === 2 && userType !== 'guest'"
        title="Delivering"
        content="Already delivered?"
        id="delivering"
        @click.native="$emit('mark-delivered')"
      ></Step>
      <Step
        v-if="statusStep !== 5 && statusStep === 2 && userType === 'guest'"
        title="Delivering"
      ></Step>
      <Step
        v-if="statusStep !== 5 && statusStep !== 2"
        title="Delivering"
        content=""
      ></Step>
      <Step
        v-show="statusStep !== 5"
        title="Delivered"
        :content="deliveryTime"
      ></Step>
      <Step v-if="statusStep === 5" title="Cancelled" content=""></Step>
    </Steps>
  </Card>
</template>

<script>
export default {
  name: "BookingStatus",
  props: {
    carrier: {
      type: String,
      default: "Freight Carrier"
    },
    sender: {
      type: String,
      default: "Freight Sender"
    },
    statusStep: Number,
    times: null,
    userType: {
      type: String,
      default: "guest"
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      hackReset: true
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    });
  },
  computed: {
    directionString: function() {
      return this.windowWidth >= 1000 ? "horizontal" : "vertical";
    },
    status: function() {
      if (this.statusStep === 4) {
        return "finish";
      }
      if (this.statusStep === 5) {
        return "error";
      }
    },
    bookTime: function() {
      if (this.times && this.times.book != null) {
        return this.times.book;
      }
      return "";
    },
    pickupTime: function() {
      if (this.times && this.times.pickup != null) {
        return this.times.pickup;
      }
      return "";
    },
    deliveryTime: function() {
      if (this.times && this.times.delivery != null) {
        return this.times.delivery;
      }
      return "";
    }
  }
};
</script>

<style scoped>
>>> #awaitingPickup .ivu-steps-content {
  text-decoration: underline;
  cursor: pointer;
}

>>> #delivering .ivu-steps-content {
  text-decoration: underline;
  cursor: pointer;
}
</style>
